import React, { useState, useEffect } from 'react'
import { moduleContext } from 'react-contextual'
import { path } from 'ramda'
import { StringParam, useQueryParam } from 'use-query-params'
import { useEffectOnce } from 'react-use'
import { DEFAULT_PERIOD } from './statementPeriods'

interface ViewStatementProviderProps {
  context: React.Context<any>
  children: React.ReactNode
  isOpen: boolean
  onClose: () => void
  onParamChange: (startDate: string, endDate: string) => void
  statementData?: any
  statementPdf?: any
  statementCsv?: any
  downloadStatement?: (startDate: string, endDate: string) => void
  downloadStatementCsv?: (startDate: string, endDate: string) => void
  pdfFileName?: string
  csvFileName?: string
}

const ViewStatementProvider = moduleContext()(({ context, children, ...props }: ViewStatementProviderProps) => {
  const currentDate = new Date()
  const [startDate, setStartDate] = useQueryParam('startDate', StringParam)
  const [endDate, setEndDate] = useQueryParam('endDate', StringParam)
  const [isLoading, setIsLoading] = useState(true)

  useEffectOnce(() => {
    // Default to the first preset so the controls bar opens with that preset already highlighted.
    const defaultRange = DEFAULT_PERIOD.range(currentDate)

    if (!startDate) {
      setStartDate(defaultRange.startDate)
    }
    if (!endDate) {
      setEndDate(defaultRange.endDate)
    }
  })

  useEffect(() => {
    setIsLoading(true)
  }, [startDate, endDate])

  useEffect(() => {
    if (path(['statementData', 'context'], props)) {
      setIsLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.statementData])

  const store = {
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    isLoading,
    ...props,
  }
  return <context.Provider value={store}>{children}</context.Provider>
})

export default ViewStatementProvider
